import * as Styled from './FolderModal.styled'

/** Элементы для модалов/попапов CRUD папок/проектов */
const FolderModal = {
  Container: Styled.Container,
  Title: Styled.Title,
  Subtitle: Styled.Subtitle,
  ButtonContainer: Styled.ButtonContainer
}

export default FolderModal
